function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/interopRequireDefault.js
// module id = 1
// module chunks = 35783957827783 70144966829960 114276838955818 198517197184460